import { render, staticRenderFns } from "./WResetPassword.vue?vue&type=template&id=55b3ef7a&scoped=true&"
import script from "./WResetPassword.vue?vue&type=script&lang=js&"
export * from "./WResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b3ef7a",
  null
  
)

export default component.exports